import { Inject, Injectable } from '@angular/core';

import { ON_SPORTS_WEB_INIT } from '@frontend/sports/common/core/feature/app-init';
import { OnAppInit } from '@frontend/vanilla/core';

@Injectable()
export class SportsWebLazyBootstrapService {
    private isAlreadyBootstrapped = false;

    constructor(@Inject(ON_SPORTS_WEB_INIT) private initializers: OnAppInit[]) {}

    async onSportsWebInit(): Promise<any> {
        if (this.isAlreadyBootstrapped) {
            return;
        }

        const promises: Promise<any>[] = [];

        for (const initializer of this.initializers) {
            const promise = initializer.onAppInit();

            if (!(promise instanceof Promise)) {
                continue;
            }

            promises.push(promise);
        }

        await Promise.all(promises);

        this.isAlreadyBootstrapped = true;
    }
}
